"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadcrumbItem = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ConfigProvider_1 = require("../ConfigProvider");
var Item_1 = require("./Item");
Object.defineProperty(exports, "BreadcrumbItem", { enumerable: true, get: function () { return tslib_1.__importDefault(Item_1).default; } });
function Breadcrumb(_a) {
    var className = _a.className, props = tslib_1.__rest(_a, ["className"]);
    var prefix = ConfigProvider_1.usePrefix('breadcrumb');
    return (react_1.default.createElement("div", tslib_1.__assign({ className: classnames_1.default(prefix, className) }, props)));
}
exports.default = Breadcrumb;
//# sourceMappingURL=index.js.map